<template>
	<PanelConfigurationSection :name="name">
		<SoftSwitch v-model="xVisible" :label="$t('dataType.vibration')" />
		<SoftSwitch v-model="oplVisible" :label="$t('dataType.overpressure')" />
	</PanelConfigurationSection>
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent, PropType } from "vue";
import PanelConfigurationSection from "../../config/PanelConfigurationSection.vue";
import { WaveformSeriesOptions } from "./event-waveform-options";

export default defineComponent({
	components: { PanelConfigurationSection },
	name: "WaveformAxisConfig",
	props: {
		modelValue: {
			type: Object as PropType<WaveformSeriesOptions>,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const xVisible = useRefObjectSync(valueModel, "vibrationVisible");
		const oplVisible = useRefObjectSync(valueModel, "oplVisible");

		return { xVisible, oplVisible };
	},
});
</script>
